import { Helmet } from 'react-helmet';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Button from '../components/ui/Button';
import { portalApi } from '../utils/portalApi';

export default function InsightArticlePage() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);

  useEffect(() => {
    portalApi.getPublicArticle(slug).then((data) => setArticle(data.article || null)).catch(() => setArticle(null));
  }, [slug]);

  if (!article) {
    return <main className="section-container py-16"><h1 className="text-2xl font-semibold text-slate-900">Article not found</h1></main>;
  }

  return (
    <main className="section-container py-10 md:py-16">
      <Helmet>
        <title>{article.seoTitle || article.title}</title>
        <meta name="description" content={article.seoDescription || article.excerpt || ''} />
      </Helmet>
      <article className="mx-auto max-w-3xl">
        <h1 className="text-3xl font-semibold tracking-tight text-slate-900 md:text-5xl">{article.title}</h1>
        <p className="mt-3 text-sm text-slate-500">
          {article.publishDate ? new Date(article.publishDate).toLocaleDateString() : ''}
          {article.author ? ` • ${article.author}` : ''}
        </p>
        {article.featuredImage ? <img src={article.featuredImage} alt="" className="mt-6 w-full rounded-2xl object-cover" /> : null}
        <div className="mt-8 whitespace-pre-wrap leading-relaxed text-slate-700">{article.body}</div>

        {(article.ctaHeadline || article.ctaText || (article.ctaButtonText && article.ctaButtonLink)) ? (
          <section className="mt-12 rounded-2xl bg-slate-50 p-6 ring-1 ring-slate-200">
            {article.ctaHeadline ? <h2 className="text-xl font-semibold text-slate-900">{article.ctaHeadline}</h2> : null}
            {article.ctaText ? <p className="mt-2 text-slate-600">{article.ctaText}</p> : null}
            {article.ctaButtonText && article.ctaButtonLink ? <Button href={article.ctaButtonLink} className="mt-4">{article.ctaButtonText}</Button> : null}
          </section>
        ) : null}
      </article>
    </main>
  );
}
